import { render } from "./BaseSearchBar.vue?vue&type=template&id=e42698e0&scoped=true"
import script from "./BaseSearchBar.vue?vue&type=script&lang=js"
export * from "./BaseSearchBar.vue?vue&type=script&lang=js"

import "./BaseSearchBar.vue?vue&type=style&index=0&id=e42698e0&scoped=true&lang=css"

import exportComponent from "C:\\xampp\\htdocs\\ms\\ms-by-bimms\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e42698e0"]])

export default __exports__